import React, { forwardRef } from 'react';
import { Button } from '@chakra-ui/react';
import type { ButtonProps } from '@chakra-ui/react';
import { themeVariables } from '@meteraprotocol/sdk/ui/theme.js';

interface PurpleButtonProps extends ButtonProps {
  primaryButtonColor?: string;
  hoverButtonColor?: string;
}

const PurpleButton = forwardRef<HTMLButtonElement, PurpleButtonProps>(
  (
    {
      primaryButtonColor = themeVariables.purple.button100,
      hoverButtonColor = themeVariables.purple.button200,
      ...props
    },
    ref,
  ) => (
    <Button
      textColor={themeVariables.primary.primary50}
      background={primaryButtonColor}
      fontSize=".875rem"
      borderRadius="0.75rem"
      isDisabled={props.disabled}
      _hover={{
        background: hoverButtonColor,
      }}
      _active={{
        bg: '#414a60',
      }}
      _disabled={{
        filter: 'grayscale(100%)',
      }}
      ref={ref}
      {...props}
    />
  ),
);

export default PurpleButton;
